export default {
  unlocked_plural: '{{count}} Angebote wurden freigeschaltet',
  unlocked: '{{offer}} Angebot wurde freigeschaltet',
  removed_one: '{{offer}} Angebot wurde entfernt',
  removed_other: '{{count}} entfernt',
};
